import { Alert, Checkbox, Form, Modal, ModalProps, message } from 'antd';
import { usePhraseContext } from '../PhraseContext';
import { platformLabelMap } from 'services/config/platform';
import toLowerCase from 'utils/toLowerCase';
import { PhrasesRootData, copyPhraseToPlatforms } from 'services/api/phrase';
import { useState } from 'react';
import { uniq } from 'lodash-es';
import { useTranslate } from '@tolgee/react';
import styled from '@emotion/styled';

function BatchCopyModal(
  props: ModalProps & { currentPlatform: General.PlatformUpperCase; phrases?: PhrasesRootData[] },
) {
  const { currentPlatform, phrases, ...otherProps } = props;

  const { t } = useTranslate();

  const { platformList } = usePhraseContext();

  const [selectedPlatforms, setSelectedPlatforms] = useState<General.PlatformUpperCase[]>([]);

  const [loading, setLoading] = useState(false);

  return (
    <Modal
      width={608}
      title={t('批量复制至其他平台')}
      okButtonProps={{
        loading,
        onClick: (e) => {
          if (selectedPlatforms.length === 0) {
            message.error(t('请选择目标平台'));
          } else {
            setLoading(true);
            copyPhraseToPlatforms({
              platform: selectedPlatforms,
              phrase: phrases || [],
            })
              .then(() => {
                message.success(t('todo.已复制'));
                otherProps.onCancel?.(e);
              })
              .catch(() => {
                message.error(t('phrase.保存失败，请稍后再试'));
              })
              .finally(() => {
                setLoading(false);
              });
          }
        },
      }}
      {...otherProps}
    >
      <Container>
        <Alert banner type="info" message={t('batchCopyPhraseTips')} />
        <Form.Item required label={t('目标平台')}>
          {platformList.map((platform) => {
            if (platform === currentPlatform) {
              return null;
            }
            return (
              <Checkbox
                key={platform}
                checked={selectedPlatforms.includes(platform)}
                onChange={({ target: { checked } }) => {
                  setSelectedPlatforms((platforms) =>
                    checked
                      ? uniq([...platforms, platform])
                      : platforms.filter((_) => _ !== platform),
                  );
                }}
              >
                {platformLabelMap[toLowerCase(platform)]}
              </Checkbox>
            );
          })}
        </Form.Item>
      </Container>
    </Modal>
  );
}

const Container = styled.div`
  > .ant-alert {
    margin: -24px -24px 24px;
    .ant-alert-icon {
      align-self: flex-start;
      margin-top: 6px;
    }
    .ant-alert-message {
      white-space: pre-wrap;
    }
  }
`;

export default BatchCopyModal;
